export default {"src":"/_next/static/media/telegram-icon.18e12898.svg","height":16,"width":16};